<template>
  <p
    :id="id"
    role="alert"
    aria-live="assertive"
    class="vs-meta vs-text vs-inline-alert"
  >
    <span
      aria-hidden="true"
      class="visa-icon-alert"
    />
    {{ message }}
  </p>
</template>

<script>
export default {
  name: 'VsInlineAlert',
  props: {
    id: { type: String, default: '' },
    message: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import './inlineAlert';
@import '@/styles/core/types/types';
</style>
